module.exports = __webpack_public_path__ + "img/service_img6.f11e79a2.png";